export default {
      id: "title-ground-services-usage",
      viewBox: "0 0 251 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-ground-services",
      toString: function () {
        return this.url;
      }
    }